export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#111111" />
    <circle cx="28" cy="28" r="11.5" stroke="#F9F8F6" strokeWidth="4" />
    <line x1="37.5" y1="37.5" x2="48" y2="48" stroke="#F9F8F6" strokeWidth="5" strokeLinecap="round" />
    <line x1="22.5" y1="28" x2="33.5" y2="28" stroke="#8C1D18" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

export default function Logo() {
  return (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
      <LogoMark className="h-8 w-8" />
      <span className="font-display text-[1.3rem] leading-none tracking-tight text-ink">
        Docket<span className="italic text-crimson">Scout</span>
      </span>
    </span>
  );
}
